import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.5 3.9165C4.66638 5.49732 2.75 8.52488 2.75 12C2.75 17.1087 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1087 21.25 12C21.25 8.54872 19.3598 5.53888 16.5582 3.94924M12 1.75V5.75",
      stroke: "var(--icon-color, #28373c)",
      "stroke-width": "var(--icon-stroke-width, 1.5)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }